import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../css/imaging.css';
import { API_BASE } from '../config';

export default function ProductsPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  const vertical = searchParams.get('vertical') || '';
  const megamenuHeading = searchParams.get('megamenu_heading') || '';
  const subCategory = searchParams.get('sub_category') || '';
  const searchQuery = searchParams.get('search') || '';
  const department = searchParams.get('department') || '';

  useEffect(() => {
    const fetchFilteredProducts = async () => {
      setLoading(true);
      try {
        // Saare parameters ko query string mein properly encode karke bhejein
        let apiUrl = `${API_BASE}/api/products?vertical=${encodeURIComponent(vertical)}&megamenu_heading=${encodeURIComponent(megamenuHeading)}&sub_category=${encodeURIComponent(subCategory)}&search=${encodeURIComponent(searchQuery)}&department=${encodeURIComponent(department)}`;
        
        const response = await axios.get(apiUrl);
        if (response.data.success) {
          let fetchedProducts = response.data.data;

          // UNIVERSAL SMART SORTING FOR ALL SUB-CATEGORIES
          if (subCategory) {
            const targetSub = subCategory.toLowerCase().trim();
            const coreKeyword = targetSub.endsWith('s') ? targetSub.slice(0, -1) : targetSub;

            fetchedProducts.sort((a, b) => {
              const subA = (a.sub_category || a.Sub_Category || '').toLowerCase().trim();
              const subB = (b.sub_category || b.Sub_Category || '').toLowerCase().trim();

              const isMatchA = subA.includes(targetSub) || (coreKeyword.length > 2 && subA.includes(coreKeyword));
              const isMatchB = subB.includes(targetSub) || (coreKeyword.length > 2 && subB.includes(coreKeyword));

              if (isMatchA && !isMatchB) return -1; 
              if (!isMatchA && isMatchB) return 1;  
              return 0;
            });
          }

          setProducts(fetchedProducts);
        }
      } catch (error) {
        console.error("Error fetching filtered products:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchFilteredProducts();
  }, [searchParams]);

  // Image cleaner helper
  const getCleanImage = (imgData) => {
    if (!imgData) return 'https://via.placeholder.com/200';
    if (Array.isArray(imgData)) return imgData[0] || 'https://via.placeholder.com/200';
    try {
      const parsed = JSON.parse(imgData);
      if (Array.isArray(parsed)) return parsed[0] || 'https://via.placeholder.com/200';
    } catch (e) {}
    if (typeof imgData === 'string' && imgData.includes(',')) {
      return imgData.split(',')[0].trim();
    }
    return String(imgData).replace(/[\[\]"]/g, "").trim() || 'https://via.placeholder.com/200';
  };

  return (
    <div className="layout-premium-wrapper" style={{ padding: '20px 40px' }}>
      <div className="breadcrumb-path" style={{ marginBottom: '20px', color: '#666' }}>
        Home / {vertical || department || 'Products'} {megamenuHeading ? `/ ${megamenuHeading}` : ''} {subCategory ? `/ ${subCategory}` : ''} {searchQuery ? `/ Search: ${searchQuery}` : ''}
      </div>

      <h2 style={{ marginBottom: '20px' }}>
        {subCategory ? subCategory : searchQuery ? `Search Results for "${searchQuery}"` : megamenuHeading || department || 'All Products'}
      </h2>

      {loading ? (
        <p style={{ textAlign: 'center', padding: '50px' }}>Loading products...</p>
      ) : products.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '60px 20px', background: '#fff', borderRadius: '8px', border: '1px solid #eee', margin: '20px 0' }}>
          <h3 style={{ color: '#333', fontSize: '22px', marginBottom: '10px' }}>🚫 This product is not available</h3>
          <p style={{ color: '#666', fontSize: '15px' }}>Sorry, we couldn't find any products matching your selection or search query right now.</p>
        </div>
      ) : (
        <div className="products-matrix-layout-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '20px' }}>
          {products.map(product => {
            const productId = product.id || product.Product_ID;
            return (
              <div 
                key={productId} 
                className="matrix-product-card-node" 
                onClick={() => navigate(`/product/${productId}`)}
                style={{ cursor: 'pointer', border: '1px solid #eee', padding: '15px', borderRadius: '8px', background: '#fff' }}
              >
                <div className="card-media-screen" style={{ height: '180px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <img 
                    src={getCleanImage(product.images || product.Images)} 
                    alt={product.title || product.Title} 
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = 'https://via.placeholder.com/200';
                    }}
                    style={{ maxHeight: '100%', maxWidth: '100%', objectFit: 'contain' }}
                  />
                </div>
                <div className="card-body-meta-details" style={{ marginTop: '15px' }}>
                  <h4 className="prod-title-heading" style={{ fontSize: '14px', height: '40px', overflow: 'hidden' }}>
                    {product.title || product.Title}
                  </h4>
                  <span className="sub-brand-category-label" style={{ fontSize: '12px', color: '#888' }}>
                    {product.sub_category || product.Sub_Category}
                  </span>
                  <div className="pricing-node-block" style={{ marginTop: '8px', fontWeight: 'bold' }}>
                    <span className="retail-price-val">₹{product.price || product.Price}</span>
                  </div>
                </div> 
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}